module.exports = __webpack_public_path__ + "static/media/SurgeonScorecard.e061cd80.jpg";